exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__1aUeT{display:flex;width:7rem;position:relative;flex:0 0 7rem}.style_colorSwatch__2rOye{width:1.5rem;height:1.5rem;border-radius:.25em;position:absolute;bottom:1rem;right:.5rem;cursor:pointer}.style_colorPickItem__249hZ{width:2.5rem;height:2.5rem;cursor:pointer;transition:background-color .1s linear;border-radius:0}.style_colorAllOptions__2ExLA{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center}", ""]);

// exports
exports.locals = {
	"container": "style_container__1aUeT",
	"colorSwatch": "style_colorSwatch__2rOye",
	"colorPickItem": "style_colorPickItem__249hZ",
	"colorAllOptions": "style_colorAllOptions__2ExLA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/ColorPicker/style.less
// module id = 1722
// module chunks = 8